import { useQuery } from "@/compat/reactQuery";
import queryKeys from "../../../constants/queryKeys";
import templateService from "../../services/templateService";

const useAllModuleEnabledTemplates = ({ moduleArea, accountId, siteExternalIds, includeDisabled = false }) =>
    useQuery(
        [queryKeys.templates, moduleArea, accountId, siteExternalIds?.join(",")],
    () =>
      templateService.fetchAllTemplatesForModule({
        moduleArea,
        accountId,
        siteExternalIds,
        includeDisabled         
      }), 
        {
            enabled: !!includeDisabled && !!siteExternalIds?.length
        }
  );

  

export default useAllModuleEnabledTemplates;
